/* eslint-disable react/prop-types */
import { Ring } from "@uiball/loaders";
import { useSelector } from "react-redux";

import { colors, strCode } from "../../../../consts";
import { t } from "../../../../services";

import {
  CircleIconButton,
  FlexContainers,
  IconButton,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../components";
import { CellWrapper } from "../../../../components/Table/styled";
import StoreInput from "../StoreInput/StoreInput";

export const StoresTableColumns = [
  {
    Header: strCode.LOCATION_NAME_TITLE,
    accessor: "name",
    Cell: ({
      cell,
      row,
      cellWidth3,
      searchedText,
      editId,
      editErrors,
      callbackFn3: onEditChanges
    }) => {
      const id = row?.original?.id;
      const isEdit = id === editId;

      const loadingLocationIds = useSelector((state) => state.configs.loadingIds);
      const isLoading = loadingLocationIds?.includes(id);

      return (
        <CellWrapper width={`calc(${cellWidth3}px - 44px)`} isSmallText>
          {isEdit || isLoading ? (
            <StoreInput
              id="name"
              initialValue={cell.value}
              placeholder={t(strCode.LOCATION_NAME_TITLE)}
              onChange={onEditChanges}
              errors={editErrors}
              disabled={isLoading}
            />
          ) : (
            <TextOverflowWrapper highlightedText={searchedText}>{cell.value}</TextOverflowWrapper>
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ADDRESS_TITLE,
    accessor: "address",
    Cell: ({ cell, row, cellWidth3, editId, editErrors, callbackFn3: onEditChanges }) => {
      const id = row?.original?.id;
      const isEdit = id === editId;

      const loadingLocationIds = useSelector((state) => state.configs.loadingIds);
      const isLoading = loadingLocationIds?.includes(id);

      return (
        <CellWrapper width={`calc(${cellWidth3}px - 30px)`} isSmallText>
          {isEdit || isLoading ? (
            <StoreInput
              id="address"
              initialValue={cell.value}
              placeholder={t(strCode.ADDRESS_PLACEHOLDER)}
              onChange={onEditChanges}
              errors={editErrors}
              disabled={isLoading}
            />
          ) : (
            <TextOverflowWrapper lines={2} maxWidth={`calc(${cellWidth3}px - 30px)`}>
              {cell.value}
            </TextOverflowWrapper>
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CITY_TITLE,
    accessor: "city",
    Cell: ({ cell, row, cellWidth5, editId, editErrors, callbackFn3: onEditChanges }) => {
      const id = row?.original?.id;
      const isEdit = id === editId;

      const loadingLocationIds = useSelector((state) => state.configs.loadingIds);
      const isLoading = loadingLocationIds?.includes(id);

      return (
        <CellWrapper width={`${cellWidth5}px`} isSmallText>
          {isEdit || isLoading ? (
            <StoreInput
              id="city"
              initialValue={cell.value}
              placeholder={t(strCode.CITY_TITLE)}
              onChange={onEditChanges}
              errors={editErrors}
              disabled={isLoading}
            />
          ) : (
            <TextOverflowWrapper>{cell.value}</TextOverflowWrapper>
          )}
        </CellWrapper>
      );
    }
  },
  {
    id: "controls",
    accessor: "id",
    Cell: ({
      cell,
      editId,
      editDisabled,
      editErrors,
      callbackFn1: onEdit,
      callbackFn2: onDelete,
      callbackFn4: onSaveChanges,
      callbackFn5: onCancel,
      callbackFn6: isReadOnlyAccess
    }) => {
      const isEdit = cell.value === editId;

      const loadingLocationIds = useSelector((state) => state.configs.loadingIds);
      const isLoading = loadingLocationIds?.includes(cell.value);

      return (
        <>
          {!isReadOnlyAccess() && (
            <CellWrapper minWidth={`88px`} justifyContent="center">
              {isLoading ? (
                <WrapperContainer Container={FlexContainers.FlexRowCenter}>
                  <Ring size={34} lineWeight={5} speed={2} color={colors.RAISIN_100} />
                </WrapperContainer>
              ) : isEdit ? (
                <WrapperContainer Container={FlexContainers.FlexRowCenter} gap={8} mr={16}>
                  <CircleIconButton
                    secondary
                    onClick={onCancel}
                    disabled={loadingLocationIds?.length}>
                    <SVG.CloseButtonIcon />
                  </CircleIconButton>

                  <CircleIconButton
                    onClick={onSaveChanges}
                    disabled={editDisabled || editErrors?.length > 0 || loadingLocationIds?.length}>
                    <SVG.CheckButtonIcon />
                  </CircleIconButton>
                </WrapperContainer>
              ) : (
                <WrapperContainer Container={FlexContainers.FlexRowCenter} gap={10} mr={8}>
                  <IconButton
                    hasHoverCircle
                    onClick={() => onDelete(cell.value)}
                    disabled={loadingLocationIds?.length}>
                    <SVG.DeleteIcon />
                  </IconButton>

                  <IconButton
                    hasHoverCircle
                    onClick={() => onEdit(cell.value)}
                    disabled={loadingLocationIds?.length}>
                    <SVG.EditIcon />
                  </IconButton>
                </WrapperContainer>
              )}
            </CellWrapper>
          )}
        </>
      );
    }
  }
];
